import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import useToggle from "./useToggle";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const ModalWrapper = ({
  initialOpen,
  title,
  size,
  children,
  render,
  onExit
}) => {
  const { toggle, hide, isOpen, show } = useToggle(initialOpen);
  useEffect(() => {
    if (initialOpen) {
      show();
    } else {
      hide();
    }
  }, [hide, initialOpen, show]);
  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={toggle} onExit={onExit} size={size}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          {typeof render === "function" ? render({ hide }) : render}
        </ModalBody>
      </Modal>
      {typeof children === "function" ? children({ show }) : children}
    </Fragment>
  );
};

ModalWrapper.propTypes = {
  initialOpen: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.element.isRequired
  ]),
  children: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.element.isRequired
  ]),
  render: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.element.isRequired
  ]),
  onExit: PropTypes.func
};

ModalWrapper.defaultProps = {
  initialOpen: false,
  size: "lg",
  onExit: () => {}
};

export default ModalWrapper;
